import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { getRecentUserCount } from '../../api/usersApi';

const DashboardReport = () => {
    const [userByStatus, setUserByStatus] = useState({})

    const metrics = [
        {
            title: 'Active founders',
            description: 'The total number of founders.',
            count: userByStatus?.founders?.total,
            change: userByStatus?.founders?.percentageChange,
        },
        {
            title: 'Active angels',
            description: 'The total number of angels.',
            count: userByStatus?.angels?.total,
            change: userByStatus?.angels?.percentageChange,
        },
        {
            title: 'Active VCs',
            description: 'The total number of VCs.',
            count: userByStatus?.vcs?.total,
            change: userByStatus?.vcs?.percentageChange,
        },
        {
            title: 'Active accelerators',
            description: 'The total number of accelerators.',
            count: userByStatus?.accelerators?.total,
            change: userByStatus?.accelerators?.percentageChange,
        },
        {
            title: 'Matches',
            description: 'The total number of matches.',
            count: userByStatus?.totalMatches?.total,
            change: userByStatus?.totalMatches?.percentageChange,
        },
    ];

    useEffect(() => {
        fetchUserByStatus()
    }, [])

    const userStatusApi = async () => {
        const data = await getRecentUserCount();
        return data;
    }

    const fetchUserByStatus = async () => {
        try {
            const res = await userStatusApi();
            setUserByStatus(res);
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className="dashboard-report-container">
            {metrics?.map((metric, index) => (
                <div className="metric-card" key={index}>
                    <h3>{metric?.title}</h3>
                    <p className="description">{metric?.description}</p>
                    <h2 className="count">{metric?.count ? metric?.count : 0}</h2>
                    <p className={`change ${metric?.change < 0 ? "changeNegative" : ""}`}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                            style={{
                                transform: metric?.change < 0 ? "rotate(180deg)" : "none",
                            }}
                        >
                            <path d="M10.0003 15.8307V4.16406M10.0003 4.16406L4.16699 9.9974M10.0003 4.16406L15.8337 9.9974"
                                stroke={metric?.change < 0 ? "#D92D20" : "#17B26A"}
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        {metric?.change ? metric?.change < 0 ? Math?.abs(metric?.change) : metric?.change : 0}% <span>vs last 30 days</span>
                    </p>

                </div>
            ))}
        </div>
    );
};

export default DashboardReport;
